export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 32 32" className={className} fill="none" aria-hidden="true">
    <path
      d="M16 2 L28 7 V16 C28 24 22 29 16 30 C10 29 4 24 4 16 V7 Z"
      fill="#0A0F1D"
      stroke="#F97316"
      strokeWidth="2"
    />
    <path
      d="M16 9 C16 9 10 15 10 19 a6 6 0 0 0 12 0 C22 15 16 9 16 9 Z"
      fill="#F97316"
    />
  </svg>
);
